
import type { Type } from "@angular/core";
import { ClearViewUtils } from "../utils";

export class AngularModuleServiceBase {
    private angularModules: Map<string, Type<any>> = new Map();
    private angularModuleSettings: Map<string, Type<any>> = new Map();

    constructor(
        fromSharedService: boolean = false,
    ) {
        if (fromSharedService)
            return AngularModuleServiceBase.getServiceBase();
    }

    static getServiceBase(): AngularModuleServiceBase {
        return ClearViewUtils.getSharedService(AngularModuleServiceBase, 'AngularModuleServiceBase');
    }

    public addAngularModule<T>(selector: string, component: Type<T>) {
        this.angularModules.set(selector, component);
    }

    public addAngularModuleSettings<T>(selector: string, component: Type<T>) {
        this.angularModuleSettings.set(selector, component);
    }

    public getAngularModule(selector: string) {
        if (this.angularModules.has(selector))
            return this.angularModules.get(selector);
        return null;
    }

    public getAngularModuleSettings(selector: string) {
        if (this.angularModuleSettings.has(selector))
            return this.angularModuleSettings.get(selector);
        return null;
    }
}
